<template>
  <form @submit.prevent="submit" novalidate class="form">
    <h1 class="title">Bienvenido a Incentivos Ferrobamba</h1>

    <label for="password" class="label">Identifíquese:</label>
    <div class="input-wrapper">
      <input
        id="password"
        v-model.trim="password"
        placeholder="Ingrese su licencia de conducir"
        autocomplete="current-password"
        required
        minlength="0"
        maxlength="10"
        class="input"
        :class="{ invalid: showError }"
        :disabled="loading"
        @input="clearError"
        aria-describedby="errorMsg"
        aria-invalid="showError.toString()"
      />
      <button
        type="button"
        class="info-btn"
        aria-label="Info about password"
        @click="toggleInfo"
        :disabled="loading"
      >
        ℹ️
      </button>
    </div>
    <p v-if="showInfo" class="help-text">
      Ingrese su licencia de conducir como identificador.
    </p>

    <p v-if="showError" class="error-text" id="errorMsg" role="alert">
      Esta licencia no está registrada en el sistema.
    </p>

    <button
      type="submit"
      class="submit-btn"
      :disabled="!isValid || loading"
    >
      {{ loading ? "Cargando..." : "Ingresar" }}
    </button>
  </form>
</template>

<script>
export default {
  name: "PasswordScreen",
  emits: ["login"],
  data() {
    return {
      password: "",
      showError: false,
      showInfo: false,
      loading: false,
    };
  },
  computed: {
    isValid() {
      return this.password.length >= 0 && this.password.length <= 10;
    },
  },
  methods: {
    toggleInfo() {
      this.showInfo = !this.showInfo;
    },
    clearError() {
      if (this.showError) this.showError = false;
    },
    async submit() {
      if (!this.isValid || this.loading) {
        this.showError = true;
        return;
      }

      this.showError = false;
      this.loading = true;

      try {
        // Modifica esta URL por la URL real de tu API Gateway
        const apiUrl = "https://dnsy6a76wc.execute-api.us-east-1.amazonaws.com/dev/incentivo";

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            },
            body: JSON.stringify({ password: this.password }),
        });

        // Obtener el json de respuesta
        const result = await response.json();

        console.log("API response:", result);

        // Verificamos el status devuelto por la API en el body del json
        if (result.statusCode === 200) {
            // Emitimos los datos del usuario (nombre, apellido, edad...) a la siguiente pantalla
            this.$emit("login", result.body);
            this.password = "";
            this.showError = false;
        } else {
            // En caso de status diferente a 200 (ej: 400) mostramos error
            this.showError = true;
        }
      } catch (error) {
        // Error de red u otro
        console.error("API error:", error);
        this.showError = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Reutiliza estilos del componente original */

.title {
  font-size: 1.8rem;
  margin-bottom: 2rem;
  color: #222;
  font-weight: 600;
  text-align: center;
}

.form {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.label {
  text-align: left;
  font-size: 1rem;
  margin-bottom: 0.4rem;
  color: #444;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input {
  flex: 1;
  padding: 12px 48px 12px 12px;
  font-size: 1.1rem;
  border: 1.5px solid #ccc;
  border-radius: 6px;
  transition: border-color 0.3s;
}

.input:focus {
  border-color: #6b8aff;
  outline: none;
}

.input.invalid {
  border-color: #e03e3e;
}

.info-btn {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.3rem;
  cursor: pointer;
  color: #6b8aff;
  padding: 0;
  user-select: none;
}

.info-btn:focus {
  outline: 2px solid #6b8aff;
  outline-offset: 2px;
}

.help-text {
  font-size: 0.8rem;
  color: #6b8aff;
  margin-top: 0.3rem;
  text-align: left;
}

.error-text {
  font-size: 0.85rem;
  color: #e03e3e;
  margin: 0.6rem 0 1rem 0;
  text-align: left;
}

.submit-btn {
  margin-top: 2rem;
  background-color: #6b8aff;
  color: white;
  padding: 14px 0;
  font-size: 1.2rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.3s;
}

.submit-btn:disabled {
  background-color: #a8bfff;
  cursor: not-allowed;
}

.submit-btn:not(:disabled):hover,
.submit-btn:not(:disabled):focus {
  background-color: #4a69e5;
  outline: none;
}
</style>